import { ArrowRightOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { useTranslation } from '@framework/i18n';
import { LinkButton, generatePath } from '@framework/ui';
import { Button, Flex, Typography } from 'antd';
import React from 'react';
import styled from 'styled-components';
const { Text, Title } = Typography;

export const BannerWrapper = styled.div`
  min-height: 30px;
  background-color: ${props => props.theme.colorInfoBg};
  padding: 12px;
`;
export const BannerIcon = styled.span`
  font-size: 24px;
  color: ${props => props.theme.colorInfo};
`;

export interface IIntegrationBannerProps {
  integrationID?: string | null;
  originalRequestId?: string | null;
  message?: React.ReactNode;
  handleShowIntegrations?: () => void;
}

/**
 * Banner di avviso in caso di richiesta integrata.
 */
export function IntegrationBanner(props: IIntegrationBannerProps) {
  const { handleShowIntegrations, originalRequestId, message } = props;
  const { t } = useTranslation();

  return (
    <BannerWrapper>
      <Flex align="center" justify="center" gap={12}>
        <BannerIcon>
          <InfoCircleOutlined aria-hidden="true" />
        </BannerIcon>
        <Text strong>{message}</Text>
        {handleShowIntegrations && (
          <Button type="link" onClick={() => handleShowIntegrations()}>
            {t(
              'integration.vai-elenco-integrazioni',
              "Vai all'elenco delle integrazioni",
            )}{' '}
            <ArrowRightOutlined aria-hidden="true" />
          </Button>
        )}
        {originalRequestId && (
          <LinkButton
            type="link"
            to={generatePath('/richieste/:id', { id: originalRequestId })}
          >
            {t(
              'integration.vai-alla-richiesta-originale',
              'Vai alla richiesta originale',
            )}{' '}
            <ArrowRightOutlined aria-hidden="true" />
          </LinkButton>
        )}
      </Flex>
    </BannerWrapper>
  );
}
